import web_socket from './web_socket'
//导出
const url = (document.location.protocol == 'http:' ? 'ws://' : 'wss://') + document.location.host + '/ws'

// const url = 'ws://kefu.jn91008.com/ws'
import global from '@/utils/global.js'

export default new web_socket(url, global.token)